import React, { type ReactElement, type ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import styles from './index.module.scss';

type LoadingSpinnerProps = {
  message?: ReactNode;
  positionAbsolute?: boolean;
};

function LoadingSpinner({ message, positionAbsolute }): ReactElement {
  return (
    <div
      className={clsx(styles.loadingSpinner, {
        [`${styles.absolutePositioning}`]: positionAbsolute
      })}
    >
      <FontAwesomeIcon spin icon="spinner" /> {message}
    </div>
  );
}

type LoadingProps = { overlay?: boolean } & LoadingSpinnerProps;

export default function Loading({
  overlay = true,
  message = 'Loading...',
  positionAbsolute = true
}: LoadingProps): ReactElement {
  const loadingSpinner = <LoadingSpinner message={message} positionAbsolute={positionAbsolute} />;

  if (overlay) {
    return (
      <div>
        <div className={styles.pageOverlay}>{loadingSpinner}</div>
      </div>
    );
  }
  return <>{loadingSpinner}</>;
}
